import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import userpic from "../img/user.png";
import { Modal } from "react-bootstrap";
import { env } from "../env/env";
import toast, { Toaster } from "react-hot-toast";

const Header = () => {
  const [ user, setuser ] = useState();
  const password = useRef();
  const [ isOpenCambio, setisOpenCambio ] = useState( false );
  const [ loggedIn, setloggedIn ] = useState();
  useEffect( () => {
    setuser( sessionStorage.getItem( "usuario" ).trim() );
    if ( user ) {
      setloggedIn( true );
    } else {
      setloggedIn( false );
    }
  }, [ user ] );

  const log_out = () => {
    sessionStorage.clear();
    setloggedIn( false );
    setuser( "" );
  };

  const cambiarpassword = async () => {
    await axios
      .post( `${ env.API_ENDPOINT }/cambiarpassword`, {
        cli_cedula: sessionStorage.getItem( "usuario" ).trim(),
        cli_password: password.current.value,
      } )
      .then( async function ( response ) {
        // handle success
        if ( response.data === "ok" ) {
          toast.success( 'Tu contraseña se ha cambiado con éxito, usa tu nueva contraseña en el próximo inicio de sesión' );
          await setisOpenCambio( false );
        }
      } )
      .catch( function ( error ) {
        // handle error
        //  console.log(error);
        toast.error( " Ha ocurrido un error!" );
      } );
  };



  return (
    <>
      {/* Topbar */ }
      <Toaster />
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
        {/* Sidebar Toggle (Topbar) */ }
        <button
          id="sidebarToggleTop"
          className="btn btn-link d-md-none rounded-circle mr-3"
        >
          <i className="fa fa-bars" />
        </button>
        {/* Topbar Search */ }
        {/* <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
          <div className="input-group">
            <input
              type="text"
              className="form-control bg-light border-0 small"
              placeholder="Search for..."
              aria-label="Search"
              aria-describedby="basic-addon2"
            />
            <div className="input-group-append">
              <button className="btn btn-primary" type="button">
                <i className="fas fa-search fa-sm" />
              </button>
            </div>
          </div>
        </form> */}
        {/* Topbar Navbar */ }
        <ul className="navbar-nav ml-auto">
          {/* Nav Item - Search Dropdown (Visible Only XS) */ }
          <li className="nav-item dropdown no-arrow d-sm-none">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="searchDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fas fa-search fa-fw" />
            </a>
            {/* Dropdown - Messages */ }
            <div
              className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
              aria-labelledby="searchDropdown"
            >
              <form className="form-inline mr-auto w-100 navbar-search">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control bg-light border-0 small"
                    placeholder="Search for..."
                    aria-label="Search"
                    aria-describedby="basic-addon2"
                  />
                  <div className="input-group-append">
                    <button className="btn btn-primary" type="button">
                      <i className="fas fa-search fa-sm" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </li>
          {/* Nav Item - Alerts */ }

          {/* Nav Item - Messages */ }

          <div className="topbar-divider d-none d-sm-block" />
          {/* Nav Item - User Information */ }
          <li className="nav-item dropdown no-arrow">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                { user }
              </span>
              <img className="img-profile rounded-circle" src={ userpic } />
            </a>
            {/* Dropdown - User Information */ }
            <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              {/*   <a className="dropdown-item" href="#">
                <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400" />
                Profile
              </a>
              <a className="dropdown-item" href="#">
                <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400" />
                Settings
              </a>
              <a className="dropdown-item" href="#">
                <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400" />
                Activity Log
              </a> */}
              <div className="dropdown-divider" />
              <a
                className="dropdown-item"
                onClick={ () => setisOpenCambio( true ) }
              >
                <i
                  className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"
                />
                Cambiar contraseña
              </a>
              { loggedIn && (
                <a
                  className="dropdown-item"
                  href="/"
                  data-toggle="modal"
                  data-target="#logoutModal"
                >
                  <i
                    className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"
                    onClick={ log_out }
                  />
                  Cerrar Sesión
                </a>
              ) }
            </div>
          </li>
        </ul>
      </nav>
      {/* End of Topbar */ }


      <Modal show={ isOpenCambio } centered>
        <Modal.Body>
          <div className="card card-danger">
            <div className="card-header">
              <h3 className="card-title">Cambio de Contraseña</h3>
            </div>

            <div className="card-body">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Contraseña nueva:</label>
                <input
                  ref={ password }
                  type="password"
                  className="form-control"
                  placeholder="Ingrese la contraseña nueva..."
                  autoFocus
                />
              </div>
              <button className="btn btn-success" onClick={ cambiarpassword }>
                Recuperar Contraseña
              </button>
              &nbsp;
              <button
                className="btn btn-primary"
                onClick={ () => setisOpenCambio( false ) }
              >
                Cerrar
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default Header;
